<form #newOrderForm="ngForm" (ngSubmit)="validate()">
  <div id="create-order-modal" class="modal-body">
    <div class="content">
      <!-- Sélection d'une des adresses du client -->
      <div class="form-group">
        <label class="form-label"
          [ngClass]="{'form-required': contextService.fullContext.company.settings.orderAddressRequired}">
          {{ 'order.selectAddress' | translate }} :
        </label>
        <div class="input-icon-wrapper">
          <i class="input-icon fa fa-map-marked-alt"></i>
          <select id="select-address" [(ngModel)]="datas.order.deliveryAddress"
            [required]="contextService.fullContext.company.settings.orderAddressRequired" (change)="fetchDates()"
            class="form-select" name="delivery-address" #address="ngModel">
            <option *ngFor="let address of datas.addresses" [ngValue]="address">{{ address.name }}, {{ address.address1
              }}, {{ address.zipCode}} {{ address.city }}</option>
          </select>
          <p class="text-error" *ngIf="newOrderForm.submitted && address.invalid">{{ 'order.emptyAddressError' |
            translate }}</p>
        </div>
      </div>

      <!-- CLA le 10/10/2019 - A/B - Sélection du type de commande -->
      <!-- <div class="form-group" *ngIf="contextService.fullContext.customer.orderTypes && contextService.fullContext.customer.orderTypes.length > 1">
        <label class="form-label form-required">
          {{ 'order.orderType' | translate }} :
        </label>
        <div class="input-icon-wrapper">
          <i class="input-icon fa fa-shopping-cart"></i>
          <select [(ngModel)]="datas.order.orderType"
                  [required]="true"
                  (change)="fetchDates()"
                  class="form-select"
                  name="orderType"
                  #orderType="ngModel">
            <option *ngFor="let orderType of contextService.fullContext.customer.orderTypes" [ngValue]="orderType.code">{{ orderType.label }}</option>
          </select>
        </div>
      </div> -->

      <!-- Liste des dates de livraisons possibles -->
      <div class="form-group">
        <label class="form-label"
          [ngClass]="{'form-required': contextService.fullContext.company.settings.orderDeliveryDateRequired}">
          {{ 'order.selectDate' | translate }} : <i class="fa fa-spin fa-circle-notch" *ngIf="loadingDates"></i>
        </label>
        <div class="input-icon-wrapper">
          <i class="input-icon fa fa-calendar-alt"></i>

          <ng-container>
            <select [(ngModel)]="datas.order.deliveryDate" [disabled]="!datas.order.deliveryAddress"
              [required]="contextService.fullContext.company.settings.orderDeliveryDateRequired"
              class="form-select select-date" name="delivery-date" #date="ngModel">
              <option disabled selected value>{{ 'order.selectDate' | translate}}</option>
              <option *ngFor="let date of dates" [ngValue]="date.deliveryDate">{{ date.comment ? date.comment :
                (date.deliveryDate | stringToDate:"fullDate") }}</option>
            </select>
            <p class="text-error" *ngIf="newOrderForm.submitted && !date.invalid">{{ 'order.emptyDateError' | translate
              }}</p>
          </ng-container>
        </div>
      </div>
      <!-- Référence client -->
      <div class="form-group">
        <label class="form-label">
          {{ 'order.customCode' | translate }}:
          <span class="tooltip" [attr.data-tooltip]="'order.customCodeTooltip' | translate">
            <i class="fa fa-info-circle"></i>
          </span>
        </label>
        <div class="input-icon-wrapper">
          <i class="input-icon fa fa-hashtag"></i>
          <input id="reference-commande-client" class="form-input" placeholder="{{ 'order.customCode' | translate }}"
            type="text" name="clientRef" [(ngModel)]="datas.order.customCode" #clientRef="ngModel" />
        </div>
        <p *ngIf="newOrderForm.submitted && clientRef.invalid">{{ 'order.customCodeError' | translate }}</p>
      </div>
      <!-- Commentaire client -->
      <div class="form-group">
        <label class="form-label">
          {{ 'order.headerComment' | translate }}:
          <span class="tooltip" [attr.data-tooltip]="'order.headerCommentTooltip' | translate">
            <i class="fa fa-info-circle"></i>
          </span>
        </label>
        <div class="input-icon-wrapper">
          <i class="input-icon fa fa-comment"></i>
          <textarea id="comment" class="form-input" placeholder="{{ 'order.headerComment' | translate }}" type="text"
            name="headerComment" [(ngModel)]="datas.order.headerComment" #headerComment="ngModel" rows="10"
            maxlength="250"></textarea>
        </div>
        <p *ngIf="newOrderForm.submitted && headerComment.invalid">{{ 'order.headerCommentError' | translate }}</p>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <button class="btn float-left" type="button" (click)="close()">
      <i class="fa fa-times"></i>
      {{ 'modal.cancelButton' | translate }}
    </button>
    <button id="validate-order" type="submit"
      [disabled]="!newOrderForm.valid
                    || (!datas.order.deliveryDate && contextService.fullContext.company.settings.orderDeliveryDateRequired)
                    || (!datas.order.deliveryAddress && contextService.fullContext.company.settings.orderAddressRequired)" class="btn btn-primary">
      <i class="fa fa-check"></i>
      {{ 'modal.validateButton' | translate }}
    </button>
  </div>
</form>